/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_Toggle_FailedInputs */

const th_push_toggle_failed = /** @type {(inputs: Push_Toggle_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปิดการแจ้งเตือนไม่สำเร็จ หากคุณออกจากระบบไปแล้ว กรุณาเข้าสู่ระบบแล้วลองอีกครั้ง`)
};

const en_push_toggle_failed = /** @type {(inputs: Push_Toggle_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not switch notifications on. If you have been signed out, sign in and try again.`)
};

const ja_push_toggle_failed = /** @type {(inputs: Push_Toggle_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知を有効にできませんでした。サインアウトされている場合は、サインインしてからもう一度お試しください。`)
};

const zh_push_toggle_failed = /** @type {(inputs: Push_Toggle_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法打开通知。若你被登出，请登录后重试。`)
};

const es_push_toggle_failed = /** @type {(inputs: Push_Toggle_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se han podido activar las notificaciones. Si se ha cerrado tu sesión, inicia sesión e inténtalo de nuevo.`)
};

const pt_push_toggle_failed = /** @type {(inputs: Push_Toggle_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível ligar as notificações. Se sua sessão caiu, entre de novo e tente outra vez.`)
};

const id_push_toggle_failed = /** @type {(inputs: Push_Toggle_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifikasi tidak bisa dinyalakan. Jika Anda keluar, masuk lalu coba lagi.`)
};

const fr_push_toggle_failed = /** @type {(inputs: Push_Toggle_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible d’activer les notifications. Si vous avez été déconnecté, reconnectez-vous et réessayez.`)
};

const tl_push_toggle_failed = /** @type {(inputs: Push_Toggle_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi nabuksan ang mga notipikasyon. Kung na-sign out ka, mag-sign in at subukang muli.`)
};

const vi_push_toggle_failed = /** @type {(inputs: Push_Toggle_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không bật được thông báo. Nếu bạn bị đăng xuất, hãy đăng nhập rồi thử lại.`)
};

const ko_push_toggle_failed = /** @type {(inputs: Push_Toggle_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`알림을 켜지 못했습니다. 로그아웃되었다면 로그인한 뒤 다시 시도하세요.`)
};

const de_push_toggle_failed = /** @type {(inputs: Push_Toggle_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungen konnten nicht eingeschaltet werden. Falls du abgemeldet wurdest, melde dich an und versuche es erneut.`)
};

const ru_push_toggle_failed = /** @type {(inputs: Push_Toggle_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось включить уведомления. Если вас разлогинило, войдите и попробуйте снова.`)
};

const tr_push_toggle_failed = /** @type {(inputs: Push_Toggle_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildirimler açılamadı. Oturumunuz kapandıysa giriş yapıp yeniden deneyin.`)
};

const it_push_toggle_failed = /** @type {(inputs: Push_Toggle_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile attivare le notifiche. Se sei stato disconnesso, accedi e riprova.`)
};

const pl_push_toggle_failed = /** @type {(inputs: Push_Toggle_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się włączyć powiadomień. Jeśli cię wylogowało, zaloguj się i spróbuj ponownie.`)
};

const uk_push_toggle_failed = /** @type {(inputs: Push_Toggle_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не вдалося ввімкнути сповіщення. Якщо вас розлогінило, увійдіть і спробуйте ще раз.`)
};

const hi_push_toggle_failed = /** @type {(inputs: Push_Toggle_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सूचनाएँ चालू नहीं हो सकीं। अगर आप साइन आउट हो गए हों, तो साइन इन करके फिर कोशिश करें।`)
};

const ar_push_toggle_failed = /** @type {(inputs: Push_Toggle_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعذّر تفعيل الإشعارات. إن خرجت من حسابك، سجّل الدخول وأعد المحاولة.`)
};

const ms_push_toggle_failed = /** @type {(inputs: Push_Toggle_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemberitahuan tidak dapat dihidupkan. Jika anda dilog keluar, log masuk dan cuba lagi.`)
};

const bn_push_toggle_failed = /** @type {(inputs: Push_Toggle_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বিজ্ঞপ্তি চালু করা যায়নি। সাইন আউট হয়ে থাকলে সাইন ইন করে আবার চেষ্টা করুন।`)
};

const zh_tw2_push_toggle_failed = /** @type {(inputs: Push_Toggle_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無法開啟通知。若你被登出，請登入後再試。`)
};

const zh_hk2_push_toggle_failed = /** @type {(inputs: Push_Toggle_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無法開啟通知。若你被登出，請登入後再試。`)
};

const ur_push_toggle_failed = /** @type {(inputs: Push_Toggle_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اطلاعات چالو نہیں ہو سکیں۔ اگر آپ سائن آؤٹ ہو گئے ہوں تو سائن اِن کر کے دوبارہ کوشش کریں۔`)
};

const fa_push_toggle_failed = /** @type {(inputs: Push_Toggle_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اعلان‌ها روشن نشد. اگر از حساب خارج شده‌اید، وارد شوید و دوباره تلاش کنید.`)
};

const sw_push_toggle_failed = /** @type {(inputs: Push_Toggle_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arifa hazikuweza kuwashwa. Kama umetolewa, ingia kisha ujaribu tena.`)
};

const nl_push_toggle_failed = /** @type {(inputs: Push_Toggle_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meldingen konden niet worden aangezet. Als je bent uitgelogd, log dan in en probeer opnieuw.`)
};

/**
* | output |
* | --- |
* | "Could not switch notifications on. If you have been signed out, sign in and try again." |
*
* @param {Push_Toggle_FailedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_toggle_failed = /** @type {((inputs?: Push_Toggle_FailedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Toggle_FailedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_push_toggle_failed(inputs)
	if (locale === "ja") return ja_push_toggle_failed(inputs)
	if (locale === "zh") return zh_push_toggle_failed(inputs)
	if (locale === "es") return es_push_toggle_failed(inputs)
	if (locale === "pt") return pt_push_toggle_failed(inputs)
	if (locale === "id") return id_push_toggle_failed(inputs)
	if (locale === "fr") return fr_push_toggle_failed(inputs)
	if (locale === "tl") return tl_push_toggle_failed(inputs)
	if (locale === "vi") return vi_push_toggle_failed(inputs)
	if (locale === "ko") return ko_push_toggle_failed(inputs)
	if (locale === "de") return de_push_toggle_failed(inputs)
	if (locale === "ru") return ru_push_toggle_failed(inputs)
	if (locale === "tr") return tr_push_toggle_failed(inputs)
	if (locale === "it") return it_push_toggle_failed(inputs)
	if (locale === "pl") return pl_push_toggle_failed(inputs)
	if (locale === "uk") return uk_push_toggle_failed(inputs)
	if (locale === "hi") return hi_push_toggle_failed(inputs)
	if (locale === "ar") return ar_push_toggle_failed(inputs)
	if (locale === "ms") return ms_push_toggle_failed(inputs)
	if (locale === "bn") return bn_push_toggle_failed(inputs)
	if (locale === "zh-TW") return zh_tw2_push_toggle_failed(inputs)
	if (locale === "zh-HK") return zh_hk2_push_toggle_failed(inputs)
	if (locale === "ur") return ur_push_toggle_failed(inputs)
	if (locale === "fa") return fa_push_toggle_failed(inputs)
	if (locale === "sw") return sw_push_toggle_failed(inputs)
	if (locale === "nl") return nl_push_toggle_failed(inputs)
	return en_push_toggle_failed(inputs)
});